// UNIFIED JOB DATA STRUCTURE
// This file ensures consistent job and company data across all screens:
// - JobsOffersScreen
// - OfferDetails
// - JobApplicationsScreen

export const UNIFIED_JOB_DATA = [
  {
    // Universal identifiers
    id: 'job_001',
    jobId: 'job_001',
    offerId: '1',
    applicationId: 'app_001',
    
    // Job information
    title: 'Senior React Developer',
    position: 'Senior React Developer', // OfferDetails compatibility
    company: 'TechCorp London',
    location: 'London, UK',
    type: 'Full-time',
    jobType: 'Full-time', // JobApplications compatibility
    remote: false,
    isRemote: false, // JobApplications compatibility
    salary: '£65,000 - £85,000',
    experience: 'Senior',
    industry: 'Technology',
    companySize: '500-1000',
    
    // Dates and timing
    posted: '2025-01-30T10:00:00.000Z',
    appliedDate: '2025-01-31T10:30:00Z',
    offerDate: '30 Jan 2025',
    startDate: '1 Mar 2025',
    deadline: '15 Feb 2025',
    
    // Status and tracking
    status: 'interview_scheduled', // Current application status
    offerStatus: 'Pending', // Offer-specific status
    matchScore: 92,
    urgent: false,
    featured: true,
    
    // Content
    description: 'We are looking for a Senior React Developer to join our growing team in London. You will be responsible for developing high-quality web applications using React, TypeScript, and modern development practices.',
    jobDescription: 'We are looking for a Senior React Developer to join our growing team in London. You will be responsible for developing high-quality web applications using React, TypeScript, and modern development practices.',
    requirements: ['5+ years React experience', 'TypeScript', 'Node.js', 'AWS'],
    benefits: [
      'Private medical insurance',
      'Pension scheme with 8% company contribution',
      'Performance-related bonus up to 15%',
      'Flexible working arrangements',
      '30 days annual leave',
      'Professional development budget',
      'Relocation assistance if required',
    ],
    responsibilities: [
      'Develop and maintain React applications',
      'Collaborate with design and backend teams',
      'Write clean, maintainable code',
      'Participate in code reviews'
    ],
    
    // Company information
    companyLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=TC',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=TC',
    
    // Contact information
    recruiterName: 'Sarah Johnson',
    recruiterEmail: 'sarah.johnson@techcorp.co.uk',
    recruiterPhone: '+44 20 7123 4567',
    contactPerson: {
      name: 'Sarah Johnson',
      role: 'HR Manager',
      email: 'sarah.johnson@techcorp.co.uk',
      phone: '+44 20 7123 4567',
      avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
    },
    
    // Application details
    coverLetter: 'I am excited to apply for the Senior React Developer position at TechCorp London. With over 5 years of experience in React development...',
    resumeVersion: 'Senior_React_Developer_Resume_v2.pdf',
    applicationNotes: 'Strong React experience, excellent portfolio',
    
    // Interview information
    interviewDate: '2025-02-05T14:00:00Z',
    interviewType: 'Technical Interview',
    interviewLocation: 'Video Call - Google Meet',
    
    // Status history
    statusHistory: [
      { status: 'submitted', date: '2025-01-31T10:30:00Z', note: 'Application submitted successfully' },
      { status: 'under_review', date: '2025-02-01T14:20:00Z', note: 'Application reviewed by hiring manager' },
      { status: 'interview_scheduled', date: '2025-02-02T09:15:00Z', note: 'Technical interview scheduled for February 5th' }
    ],
    
    // Additional details for OfferDetails
    additionalDetails: {
      department: 'Engineering - Frontend',
      reportsTo: 'Engineering Director',
      workSchedule: 'Monday to Friday, 9am - 5pm',
      probationPeriod: '3 months',
      overtimePolicy: 'Compensated with time off in lieu',
      travelRequirements: 'Minimal travel required (less than 5%)',
    },
    
    // Location details
    distance: '12 miles',
    commuteTime: '45 mins',
  },
  {
    // Universal identifiers
    id: 'job_002',
    jobId: 'job_002',
    offerId: '2',
    applicationId: 'app_002',
    
    // Job information
    title: 'Frontend Engineer',
    position: 'Frontend Engineer',
    company: 'StartupHub Manchester',
    location: 'Manchester, UK',
    type: 'Full-time',
    jobType: 'Full-time',
    remote: true,
    isRemote: true,
    salary: '£45,000 - £60,000',
    experience: 'Mid-level',
    industry: 'Technology',
    companySize: '100-500',
    
    // Dates and timing
    posted: '2025-01-29T14:30:00.000Z',
    appliedDate: '2025-01-30T16:45:00Z',
    offerDate: '29 Jan 2025',
    startDate: '15 Feb 2025',
    deadline: '10 Feb 2025',
    
    // Status and tracking
    status: 'offer_received',
    offerStatus: 'Pending',
    matchScore: 85,
    urgent: true,
    featured: false,
    
    // Content
    description: 'Frontend Engineer role in a fast-growing startup environment. You will work with React, Vue.js, and modern frontend technologies to build user-facing applications.',
    jobDescription: 'Frontend Engineer role in a fast-growing startup environment. You will work with React, Vue.js, and modern frontend technologies to build user-facing applications.',
    requirements: ['React/Vue.js', 'JavaScript/TypeScript', 'CSS/SASS', 'Git'],
    benefits: [
      'Equity options',
      'Flexible hours',
      'Learning budget',
      'Free lunch',
      'Health insurance',
      'Remote work allowance',
      'Professional certification support',
    ],
    responsibilities: [
      'Build responsive web applications',
      'Optimize application performance',
      'Work with UX/UI designers',
      'Maintain code quality standards'
    ],
    
    // Company information
    companyLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=SH',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=SH',
    
    // Contact information
    recruiterName: 'Michael Brown',
    recruiterEmail: 'michael.brown@startuphub.co.uk',
    recruiterPhone: '+44 161 234 5678',
    contactPerson: {
      name: 'Michael Brown',
      role: 'Talent Acquisition Manager',
      email: 'michael.brown@startuphub.co.uk',
      phone: '+44 161 234 5678',
      avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    },
    
    // Application details
    coverLetter: 'I am thrilled to apply for the Frontend Engineer position at StartupHub Manchester. My experience with React and Vue.js...',
    resumeVersion: 'Frontend_Engineer_Resume_v1.pdf',
    applicationNotes: 'Great startup experience, strong frontend skills',
    
    // Interview information
    interviewDate: '2025-02-03T10:00:00Z',
    interviewType: 'Technical + Cultural Fit',
    interviewLocation: 'Remote - Zoom',
    
    // Status history
    statusHistory: [
      { status: 'submitted', date: '2025-01-30T16:45:00Z', note: 'Application submitted successfully' },
      { status: 'under_review', date: '2025-01-31T11:30:00Z', note: 'Application reviewed by CTO' },
      { status: 'interview_completed', date: '2025-02-03T11:00:00Z', note: 'Technical interview completed successfully' },
      { status: 'offer_received', date: '2025-02-04T15:20:00Z', note: 'Job offer received with competitive package' }
    ],
    
    // Additional details for OfferDetails
    additionalDetails: {
      department: 'Engineering - Frontend',
      reportsTo: 'Engineering Team Lead',
      workSchedule: 'Flexible hours, core hours 10am - 3pm',
      probationPeriod: '3 months',
      overtimePolicy: 'Flexible time off for additional hours worked',
      travelRequirements: 'Quarterly team meetups (4 times per year)',
    },
    
    // Location details
    distance: 'Remote',
    commuteTime: '0 mins',
  },
  {
    // Universal identifiers
    id: 'job_003',
    jobId: 'job_003',
    offerId: '3',
    applicationId: 'app_003',
    
    // Job information
    title: 'Full Stack Developer',
    position: 'Full Stack Developer',
    company: 'FinTech Solutions Edinburgh',
    location: 'Edinburgh, UK',
    type: 'Contract',
    jobType: 'Contract',
    remote: true,
    isRemote: true,
    salary: '£400 - £600 per day',
    experience: 'Senior',
    industry: 'FinTech',
    companySize: '200-500',
    
    // Dates and timing
    posted: '2025-01-29T09:15:00.000Z',
    appliedDate: '2025-01-29T20:15:00Z',
    offerDate: '29 Jan 2025',
    startDate: '1 Mar 2025',
    deadline: '20 Feb 2025',
    
    // Status and tracking
    status: 'under_review',
    offerStatus: 'Pending',
    matchScore: 78,
    urgent: false,
    featured: true,
    
    // Content
    description: 'Join our FinTech team to build innovative financial applications. Work with modern technologies including React, Node.js, and cloud platforms.',
    jobDescription: 'Join our FinTech team to build innovative financial applications. Work with modern technologies including React, Node.js, and cloud platforms.',
    requirements: ['Full-stack development', 'React/Node.js', 'Financial services', 'Cloud platforms'],
    benefits: [
      'High day rate',
      'Remote work',
      'Flexible schedule',
      'Latest technology',
      'Professional development',
      'Contract extension opportunities',
      'Equipment allowance',
    ],
    responsibilities: [
      'Develop full-stack financial applications',
      'Implement secure payment systems',
      'Work with compliance requirements',
      'Optimize application performance'
    ],
    
    // Company information
    companyLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=FS',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=FS',
    
    // Contact information
    recruiterName: 'Emma Wilson',
    recruiterEmail: 'emma.wilson@fintech.co.uk',
    recruiterPhone: '+44 131 456 7890',
    contactPerson: {
      name: 'Emma Wilson',
      role: 'Recruiter',
      email: 'emma.wilson@fintech.co.uk',
      phone: '+44 131 456 7890',
      avatar: 'https://randomuser.me/api/portraits/women/67.jpg',
    },
    
    // Application details
    coverLetter: 'I am writing to express my interest in the Full Stack Developer position at FinTech Solutions Edinburgh...',
    resumeVersion: 'FullStack_FinTech_Resume_v1.pdf',
    applicationNotes: 'Strong fintech background, excellent technical skills',
    
    // Interview information
    interviewDate: null,
    interviewType: null,
    interviewLocation: null,
    
    // Status history
    statusHistory: [
      { status: 'submitted', date: '2025-01-29T20:15:00Z', note: 'Application submitted successfully' },
      { status: 'under_review', date: '2025-01-30T09:30:00Z', note: 'Application under review by technical team' }
    ],
    
    // Additional details for OfferDetails
    additionalDetails: {
      department: 'Software Engineering',
      reportsTo: 'Software Team Lead',
      workSchedule: 'Monday to Friday, flexible hours',
      probationPeriod: 'N/A (Contract)',
      overtimePolicy: 'Included in day rate',
      travelRequirements: 'Occasional client meetings (10-15%)',
    },
    
    // Location details
    distance: '280 miles',
    commuteTime: 'Remote',
  },
  {
    // Universal identifiers
    id: 'job_004',
    jobId: 'job_004',
    offerId: '4',
    applicationId: 'app_004',
    
    // Job information
    title: 'UX/UI Designer',
    position: 'UX/UI Designer',
    company: 'DesignStudio Pro',
    location: 'Birmingham, UK',
    type: 'Full-time',
    jobType: 'Full-time',
    remote: false,
    isRemote: false,
    salary: '£40,000 - £55,000',
    experience: 'Mid-level',
    industry: 'Design',
    companySize: '50-100',
    
    // Dates and timing
    posted: '2025-01-28T16:45:00.000Z',
    appliedDate: '2025-01-29T11:20:00Z',
    offerDate: '28 Jan 2025',
    startDate: '15 Mar 2025',
    deadline: '25 Feb 2025',
    
    // Status and tracking
    status: 'interview_completed',
    offerStatus: 'Pending',
    matchScore: 94,
    urgent: false,
    featured: false,
    
    // Content
    description: 'Create beautiful and intuitive user experiences for web and mobile applications. Join our creative team and work on exciting projects.',
    jobDescription: 'Create beautiful and intuitive user experiences for web and mobile applications. Join our creative team and work on exciting projects.',
    requirements: ['Figma/Sketch expertise', 'User research', 'Prototyping', 'Design systems'],
    benefits: [
      'Creative environment',
      'Professional development',
      'Health insurance',
      'Team events',
      'Design software licenses',
      'Flexible working hours',
    ],
    responsibilities: [
      'Design user interfaces for web and mobile',
      'Conduct user research and testing',
      'Create design systems and guidelines',
      'Collaborate with development teams'
    ],
    
    // Company information
    companyLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=DS',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=DS',
    
    // Contact information
    recruiterName: 'James Taylor',
    recruiterEmail: 'james.taylor@designstudio.co.uk',
    recruiterPhone: '+44 121 789 0123',
    contactPerson: {
      name: 'James Taylor',
      role: 'Design Director',
      email: 'james.taylor@designstudio.co.uk',
      phone: '+44 121 789 0123',
      avatar: 'https://randomuser.me/api/portraits/men/28.jpg',
    },
    
    // Application details
    coverLetter: 'I am passionate about creating exceptional user experiences and would love to join DesignStudio Pro...',
    resumeVersion: 'UX_Designer_Portfolio_v3.pdf',
    applicationNotes: 'Excellent design portfolio, strong UX background',
    
    // Interview information
    interviewDate: '2025-02-01T15:30:00Z',
    interviewType: 'Design Portfolio Review',
    interviewLocation: 'Birmingham Office',
    
    // Status history
    statusHistory: [
      { status: 'submitted', date: '2025-01-29T11:20:00Z', note: 'Application and portfolio submitted' },
      { status: 'under_review', date: '2025-01-30T10:15:00Z', note: 'Portfolio reviewed by design team' },
      { status: 'interview_scheduled', date: '2025-01-31T16:45:00Z', note: 'Portfolio review interview scheduled' },
      { status: 'interview_completed', date: '2025-02-01T16:30:00Z', note: 'Portfolio review completed successfully' }
    ],
    
    // Additional details for OfferDetails
    additionalDetails: {
      department: 'Design Team',
      reportsTo: 'Design Director',
      workSchedule: 'Monday to Friday, 9am - 5:30pm',
      probationPeriod: '3 months',
      overtimePolicy: 'Flexible time off for additional hours worked',
      travelRequirements: 'Client meetings as needed (5-10%)',
    },
    
    // Location details
    distance: '95 miles',
    commuteTime: '2 hours',
  },
  {
    // Universal identifiers
    id: 'job_005',
    jobId: 'job_005',
    offerId: '5',
    applicationId: 'app_005',
    
    // Job information
    title: 'DevOps Engineer',
    position: 'DevOps Engineer',
    company: 'CloudTech Systems',
    location: 'Remote, UK',
    type: 'Full-time',
    jobType: 'Full-time',
    remote: true,
    isRemote: true,
    salary: '£55,000 - £70,000',
    experience: 'Mid-level',
    industry: 'Technology',
    companySize: '50-100',
    
    // Dates and timing
    posted: '2025-01-27T13:10:00.000Z',
    appliedDate: '2025-01-28T09:30:00Z',
    offerDate: '27 Jan 2025',
    startDate: '1 Apr 2025',
    deadline: '28 Feb 2025',
    
    // Status and tracking
    status: 'rejected',
    offerStatus: 'Rejected',
    matchScore: 89,
    urgent: true,
    featured: true,
    
    // Content
    description: 'Build and maintain cloud infrastructure and deployment pipelines. Work with modern DevOps tools and practices.',
    jobDescription: 'Build and maintain cloud infrastructure and deployment pipelines. Work with modern DevOps tools and practices.',
    requirements: ['AWS/Azure', 'Docker/Kubernetes', 'CI/CD', 'Infrastructure as Code'],
    benefits: [
      '100% Remote',
      'Equipment allowance',
      'Training budget',
      'Flexible hours',
      'Health insurance',
      'Pension scheme',
    ],
    responsibilities: [
      'Manage cloud infrastructure',
      'Implement CI/CD pipelines',
      'Monitor system performance',
      'Ensure security best practices'
    ],
    
    // Company information
    companyLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=CT',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=CT',
    
    // Contact information
    recruiterName: 'Lisa Anderson',
    recruiterEmail: 'lisa.anderson@cloudtech.co.uk',
    recruiterPhone: '+44 20 8901 2345',
    contactPerson: {
      name: 'Lisa Anderson',
      role: 'Technical Recruiter',
      email: 'lisa.anderson@cloudtech.co.uk',
      phone: '+44 20 8901 2345',
      avatar: 'https://randomuser.me/api/portraits/women/42.jpg',
    },
    
    // Application details
    coverLetter: 'I am excited to apply for the DevOps Engineer position at CloudTech Systems...',
    resumeVersion: 'DevOps_Engineer_Resume_v2.pdf',
    applicationNotes: 'Strong cloud infrastructure experience',
    
    // Interview information
    interviewDate: '2025-01-30T14:00:00Z',
    interviewType: 'Technical Assessment',
    interviewLocation: 'Remote - Teams',
    
    // Status history
    statusHistory: [
      { status: 'submitted', date: '2025-01-28T09:30:00Z', note: 'Application submitted successfully' },
      { status: 'under_review', date: '2025-01-29T08:15:00Z', note: 'Application reviewed by DevOps team' },
      { status: 'interview_scheduled', date: '2025-01-29T17:30:00Z', note: 'Technical assessment scheduled' },
      { status: 'interview_completed', date: '2025-01-30T15:00:00Z', note: 'Technical assessment completed' },
      { status: 'rejected', date: '2025-02-01T10:00:00Z', note: 'Position filled by internal candidate' }
    ],
    
    // Additional details for OfferDetails
    additionalDetails: {
      department: 'Infrastructure Team',
      reportsTo: 'DevOps Team Lead',
      workSchedule: 'Flexible hours, on-call rotation',
      probationPeriod: '3 months',
      overtimePolicy: 'Compensated for on-call duties',
      travelRequirements: 'Occasional data center visits (5%)',
    },
    
    // Location details
    distance: 'Remote',
    commuteTime: '0 mins',
  },
  {
    // Universal identifiers
    id: 'job_006',
    jobId: 'job_006',
    offerId: '6',
    applicationId: 'app_006',
    
    // Job information
    title: 'Product Manager',
    position: 'Product Manager',
    company: 'InnovateLab',
    location: 'Bristol, UK',
    type: 'Full-time',
    jobType: 'Full-time',
    remote: false,
    isRemote: false,
    salary: '£60,000 - £75,000',
    experience: 'Senior',
    industry: 'Technology',
    companySize: '100-500',
    
    // Dates and timing
    posted: '2025-01-26T11:20:00.000Z',
    appliedDate: '2025-01-27T14:45:00Z',
    offerDate: '26 Jan 2025',
    startDate: '1 May 2025',
    deadline: '15 Mar 2025',
    
    // Status and tracking
    status: 'submitted',
    offerStatus: 'Pending',
    matchScore: 81,
    urgent: false,
    featured: false,
    
    // Content
    description: 'Lead product strategy and development for our flagship products. Work closely with engineering and design teams.',
    jobDescription: 'Lead product strategy and development for our flagship products. Work closely with engineering and design teams.',
    requirements: ['3+ years PM experience', 'Agile/Scrum', 'Data analysis', 'Stakeholder management'],
    benefits: [
      'Stock options',
      'Flexible hours',
      'Professional development',
      'Team building',
      'Health insurance',
      'Pension scheme',
    ],
    responsibilities: [
      'Define product roadmap and strategy',
      'Work with cross-functional teams',
      'Analyze market trends and user feedback',
      'Manage product lifecycle'
    ],
    
    // Company information
    companyLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=IL',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=IL',
    
    // Contact information
    recruiterName: 'David Clark',
    recruiterEmail: 'david.clark@innovatelab.co.uk',
    recruiterPhone: '+44 117 345 6789',
    contactPerson: {
      name: 'David Clark',
      role: 'Product Director',
      email: 'david.clark@innovatelab.co.uk',
      phone: '+44 117 345 6789',
      avatar: 'https://randomuser.me/api/portraits/men/35.jpg',
    },
    
    // Application details
    coverLetter: 'I am excited to apply for the Product Manager position at InnovateLab...',
    resumeVersion: 'Product_Manager_Resume_v1.pdf',
    applicationNotes: 'Strong product management background',
    
    // Interview information
    interviewDate: null,
    interviewType: null,
    interviewLocation: null,
    
    // Status history
    statusHistory: [
      { status: 'submitted', date: '2025-01-27T14:45:00Z', note: 'Application submitted successfully' }
    ],
    
    // Additional details for OfferDetails
    additionalDetails: {
      department: 'Product Team',
      reportsTo: 'VP of Product',
      workSchedule: 'Monday to Friday, flexible hours',
      probationPeriod: '6 months',
      overtimePolicy: 'Compensated for approved overtime',
      travelRequirements: 'Regular client meetings (15-20%)',
    },
    
    // Location details
    distance: '120 miles',
    commuteTime: '2.5 hours',
  },
];

// Helper functions for data consistency
export const getJobById = (id) => {
  return UNIFIED_JOB_DATA.find(job => 
    job.id === id || 
    job.jobId === id || 
    job.offerId === id || 
    job.applicationId === id
  );
};

export const getJobsForOffers = () => {
  return UNIFIED_JOB_DATA.map(job => ({
    ...job,
    // Ensure OfferDetails compatibility
    position: job.title,
    logo: job.companyLogo,
  }));
};

export const getJobsForApplications = () => {
  return UNIFIED_JOB_DATA.filter(job => job.appliedDate).map(job => ({
    ...job,
    // Ensure JobApplications compatibility
    jobTitle: job.title,
    jobType: job.type,
    isRemote: job.remote,
  }));
};

export const getOffersForDetails = () => {
  return UNIFIED_JOB_DATA.map(job => ({
    ...job,
    // Ensure OfferDetails compatibility
    position: job.title,
    logo: job.companyLogo,
    status: job.offerStatus,
  }));
};

// Status mapping helpers
export const mapApplicationStatusToOfferStatus = (appStatus) => {
  switch (appStatus) {
    case 'offer_received':
    case 'offer_accepted':
      return 'Accepted';
    case 'rejected':
      return 'Rejected';
    case 'withdrawn':
      return 'Withdrawn';
    default:
      return 'Pending';
  }
};

export const mapOfferStatusToApplicationStatus = (offerStatus) => {
  switch (offerStatus) {
    case 'Accepted':
      return 'offer_accepted';
    case 'Rejected':
      return 'rejected';
    case 'Withdrawn':
      return 'withdrawn';
    default:
      return 'offer_received';
  }
};

// Company data for consistency
export const COMPANY_DATA = {
  'TechCorp London': {
    name: 'TechCorp London',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=TC',
    industry: 'Technology',
    size: '500-1000',
    location: 'London, UK',
  },
  'StartupHub Manchester': {
    name: 'StartupHub Manchester',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=SH',
    industry: 'Technology',
    size: '100-500',
    location: 'Manchester, UK',
  },
  'FinTech Solutions Edinburgh': {
    name: 'FinTech Solutions Edinburgh',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=FS',
    industry: 'FinTech',
    size: '200-500',
    location: 'Edinburgh, UK',
  },
  'DesignStudio Pro': {
    name: 'DesignStudio Pro',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=DS',
    industry: 'Design',
    size: '50-100',
    location: 'Birmingham, UK',
  },
  'CloudTech Systems': {
    name: 'CloudTech Systems',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=CT',
    industry: 'Technology',
    size: '50-100',
    location: 'Remote, UK',
  },
  'InnovateLab': {
    name: 'InnovateLab',
    logo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=IL',
    industry: 'Technology',
    size: '100-500',
    location: 'Bristol, UK',
  },
};

